import { useSync } from "#/lib/api/react-query/useSync"
import { useSession } from "#/lib/auth/session-context"

/**
 * useUsername is a react hook that will return the decrypted username
 */
export function useUsername() {
  const { session } = useSession()
  return useSync({
    query: {
      staleTime: Infinity,
      enabled: !!session,
      select(data) {
        return data.publicProfile.username
      },
    },
  })
}
